module.exports = __webpack_public_path__ + "assets/fabric.7e958c56.svg";